export default __webpack_public_path__ + "static/media/anootation-toolkit.64c56ef2.png";